import React, { FC, useEffect, useId, useRef, useState } from "react";
import Heading from "components/Heading/Heading";
import Glide from "@glidejs/glide";
import CollectionCard from "./CollectionCard";
import CollectionCard2 from "./CollectionCard2";
import { Link } from "react-router-dom";
//import { DEMO_LARGE_PRODUCTS } from "./SectionSliderLargeProduct2";
import axios from 'axios';
import API_HOST from '../config/config';
import { useAuth } from '../contains/AuthContext';

export interface SectionSliderLargeProductProps {
  className?: string;
  itemClassName?: string;
  cardStyle?: "style1" | "style2";
}

interface product {
  id:number;
  name:string;
  images: string[];
  price: number;
  description: string;
  sort_description:string;
  review_count?: number;
  average_review?: number;
  link?:string;
}

const SectionSliderLargeProduct: FC<SectionSliderLargeProductProps> = ({
  className = "",
  cardStyle = "style2",
}) => {
  const sliderRef = useRef(null);
  const id = useId();
  const UNIQUE_CLASS = "glidejs" + id.replace(/:/g, "_");
  const { user } = useAuth();
  const [products, setProducts] = useState([]);
  useEffect(() => {
    const fetchData = async () => { 
      try {
        axios.post(API_HOST+'/api/get-home-data',{
          nopaginate : '1',
          status : '1',
          order : 'desc',
          type:'chosen_by_products',
          user_id:user?user.id:'0'
        })
        .then(response => {
          if(response.data.success === 0)
          {
            setProducts(response.data.data.chosen_by_products);
          }
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });  
  
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
  
    fetchData();
  }, []);

  useEffect(() => {
    if (!sliderRef.current) {
      return () => {};
    }
    // @ts-ignore
    const OPTIONS: Glide.Options = {
      perView: 3,
      gap: 32,
      bound: true,
      breakpoints: {
        1280: {
          gap: 28,
          perView: 3,
        },
        1023: {
          gap: 20,
          perView: 2,
        },
        767: {
          gap: 20,
          perView: 1.5,
        },

        500: {
          gap: 20,
          perView: 1.2,
        },
      },
    };

    let slider = new Glide(`.${UNIQUE_CLASS}`, OPTIONS);
    slider.mount();
    return () => {
      slider.destroy();
    };
  }, [products, sliderRef, UNIQUE_CLASS]);

  const MyCollectionCard =
    cardStyle === "style1" ? CollectionCard : CollectionCard2;

  return (
    <>
    <div className={`nc-SectionSliderLargeProduct ${className}`}>
      {products.length > 0 &&  
      <div className={`${UNIQUE_CLASS} flow-root`} ref={sliderRef}>
        <Heading isCenter={false} hasNextPrev>
          Chosen by our experts
        </Heading>
        <div className="glide__track" data-glide-el="track">
          <ul className="glide__slides">
            {products.map((product:product, index) => (
              <li className={`glide__slide`} key={index}>
                <MyCollectionCard
                  name={product.name}
                  price={product.price}
                  imgs={product.images}
                  description={product.sort_description}
                  review_count={product.review_count}
                  average_review={product.average_review}
                  link={product.link}
                />
              </li>
            ))}

            <li className={`hidden glide__slide   `}>
              <Link to={"/page-search"} className="block relative group">
                <div className="relative rounded-2xl overflow-hidden h-[410px]">
                  <div className="h-[410px] bg-black/5 dark:bg-neutral-800"></div>
                  <div className="absolute inset-y-6 inset-x-10  flex flex-col items-center justify-center">
                    <div className="flex items-center justify-center relative">
                      <span className="text-xl font-semibold">More items</span>
                      <svg
                        className="absolute left-full w-5 h-5 ml-2 rotate-45 group-hover:scale-110 transition-transform"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.0701 9.57L12.0001 3.5L5.93005 9.57"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12 20.4999V3.66992"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <span className="text-sm mt-1">Show me more</span>
                  </div>
                </div>
              </Link>
            </li>
          </ul>
        </div>
      </div>
      }
    </div>

    {/* --- skeletant-design --- */}
    <div className="skeletant-target hidden">
      <div className="skeletant-design ld-no-img h-[30px] max-w-[200px] mt-4 mb-8"></div>
      <div className="grid grid-cols-[1] lg:grid-cols-3 gap-5">

        <div className="w-full flex">
          <div className="w-full">
            <div className="skeletant-design h-[340px] w-full"></div>
            <div className="grid grid-cols-3 gap-2 my-2">
              <div className="skeletant-design h-[100px]"></div>
              <div className="skeletant-design h-[100px]"></div>
              <div className="skeletant-design h-[100px]"></div>
            </div>
          </div>
          <div className="w-[20%] pl-4 block md:hidden">
            <div className="skeletant-design ld-no-img h-[340px] w-full"></div>
            <div className="grid grid-cols-1 gap-2 my-2">
              <div className=" ld-no-img h-[100px]"></div>
            </div>
          </div>
        </div>

        <div className="w-full hidden md:block">
            <div className="skeletant-design h-[340px] w-full"></div>
            <div className="grid grid-cols-3 gap-2 my-2">
              <div className="skeletant-design h-[100px]"></div>
              <div className="skeletant-design h-[100px]"></div>
              <div className="skeletant-design h-[100px]"></div>
            </div>
        </div>

        <div className="w-full hidden lg:block">
            <div className="skeletant-design h-[340px] w-full"></div>
            <div className="grid grid-cols-3 gap-2 my-2">
              <div className="skeletant-design h-[100px]"></div>
              <div className="skeletant-design h-[100px]"></div>
              <div className="skeletant-design h-[100px]"></div>
            </div>
        </div>
          
      </div>
    </div>
    {/* --- skeletant-design --- */}
    </>
  );
};

export default SectionSliderLargeProduct;
